<template>
  <div>
    <Loader :loader-primario="loader" />

    <Alerta
      v-on:fecharModal="fecharModal"
      :exibir="modal.exibir"
      :titulo="modal.titulo"
      :mensagem="modal.mensagem"
    />

    <v-container>
      <v-row>
        <v-col cols="12" md="8" lg="10">
          <h2 class="titulo-avaliacao titulo-secao">
            Plano de Desenvolvimento Individual
            <span>Defina metas, desenvolva habilidades e acompanhe seu progresso</span>
          </h2>
        </v-col>
        <v-col v-show="!isForm" cols="12" md="4" lg="2">
          <v-btn @click="toggleForm()" class="botao-principal w-100">
            <v-icon class="mr-2">fas fa-circle-plus</v-icon>
            Adicionar
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <ViewInicialPdi
      v-show="!isForm"
      :listaPdi="listaPdi"
      :historicoProgresso="historicoProgresso"
      @toggle-form="toggleForm"
    />

    <ViewFormPdi
      v-show="isForm"
      :idPdi="idPdi"
      :dadosColaborador="dadosColaborador"
      @toggle-form="toggleForm"
      @save-form="handleSaveForm"
      @error="message => mensagemErro(message)"
    />
  </div>
</template>

<script>
import Loader from '@/components/Loader.vue';
import Alerta from '@/components/Alerta.vue';
import Aviso from '@/components/Aviso.vue';
import ViewInicialPdi from './Pdi/ViewInicialPdi.vue';
import ViewFormPdi from './Pdi/ViewFormPdi.vue';
import modalMixin from '@/mixins/modalMixin';
import api from '@/services/Api.js';

export default {
  name: 'Pdi',
  components: { Loader, Alerta, Aviso, ViewInicialPdi, ViewFormPdi },
  mixins: [modalMixin],
  props: {
    cod_avaliacao: { type: Number, default: null },
  },
  data() {
    return {
      loader: false,
      isForm: false,

      ciclo: {},
      listaPdi: [],
      historicoProgresso: [],

      idPdi: null,
      dadosColaborador: {},
    };
  },
  methods: {
    toggleForm(id = null) {
      this.idPdi = id;
      this.isForm = !this.isForm;
    },
    async fetchCiclos() {
      this.loader = true;
      try {
        const { status, data } = await api.get(`avaliacaoDesempenho/ciclosColaborador`, {
          headers: { Authorization: localStorage.token },
          withCredentials: true,
          params: { page: 1, perPage: 10 },
        });
        if (status !== 200) return;

        // pegando ciclo mais recente pois o back traz ordenador de forma descrente
        this.ciclo = data.result[0];
        this.fetchPdiList();
        this.fetchProgresso();
        this.fetchDadosColaborador();
      } catch (e) {
        this.mensagemErro(e.message);
      } finally {
        this.loader = false;
      }
    },
    async fetchPdiList() {
      if (!this.ciclo.codAvaliacao) return;

      try {
        const { data } = await api.get(`pdi/avaliacao/${this.ciclo.codAvaliacao}`);
        this.listaPdi = data;
      } catch (e) {
        this.mensagemErro(e.message);
      }
    },
    async fetchProgresso() {
      if (!this.ciclo.codAvaliacao) return;

      try {
        const { data } = await api.get(
          `pdi/acompanhamento-progresso-avaliacao/${this.ciclo.codAvaliacao}`
        );
        this.historicoProgresso = data;
      } catch (e) {
        this.mensagemErro(e.message);
      }
    },
    async fetchDadosColaborador() {
      try {
        const { data } = await api.get(`AutoAvaliados/getDadosByCodCicloColaborador/`, {
          params: { cod_ciclo_colaborador: this.ciclo.codAutoAvaliacao },
        });
        this.dadosColaborador = data;
      } catch (e) {
        this.mensagemErro(e.message);
      }
    },
    async handleSaveForm(idPdi, planoAcao) {
      const modalSucesso =
        planoAcao.idStatus === 4
          ? [
              false,
              'Seu objetivo está em processo de validação pelo gestor. Aguarde o retorno para confirmação da finalização.',
            ]
          : [true, 'As informações foram enviada e salvas com sucesso no sistema!'];

      try {
        if (!idPdi) {
          planoAcao.codAvaliacao = this.ciclo.codAvaliacao;
          await api.post(`pdi/criar`, planoAcao);

          modalSucesso[0]
            ? this.mensagemSucesso(modalSucesso[1])
            : this.mensagem('Aviso!', modalSucesso[1]);
          window.location.reload();
          return;
        }

        await api.put(`pdi/salvar-progresso`, {
          id: idPdi,
          idStatus: planoAcao.idStatus,
          comentario: planoAcao.comentario,
        });

        modalSucesso[0]
          ? this.mensagemSucesso(modalSucesso[1])
          : this.mensagem('Aviso!', modalSucesso[1]);
        window.location.reload();
      } catch (e) {
        this.mensagemErro(e.message);
      }
    },
  },
  async mounted() {
    await this.fetchCiclos();
  },
};
</script>
